/**
 * @file index.js
 * @description Entry point for the E-Operations web portal.
 *
 * @project E-Operations
 * @version 1.0.0
 * @license PITC
 * @author Afan Javed
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { pruneStaleStorage } from "./utils/pruneStaleStorage";
import { installFetchNetworkInterceptor } from "./utils/networkConnectivity";
import "./style/appTheme.scss";

pruneStaleStorage();
installFetchNetworkInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate
      loading={
        <div
          style={{ minHeight: "100vh", backgroundColor: "#F3F6FB" }}
          aria-busy="true"
        />
      }
      persistor={persistor}
    >
      <App />
    </PersistGate>
  </Provider>
);
